var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5 5.5C14.8808 5.5 16 4.38083 16 3C16 1.61917 14.8808 0.5 13.5 0.5C12.1192 0.5 11 1.61917 11 3C11 4.38083 12.1192 5.5 13.5 5.5ZM13.5 1.05556C14.5719 1.05556 15.4444 1.92778 15.4444 3C15.4444 4.07222 14.5719 4.94444 13.5 4.94444C12.4281 4.94444 11.5556 4.07222 11.5556 3C11.5556 1.92778 12.4281 1.05556 13.5 1.05556Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.5 15.5C4.88083 15.5 6 14.3808 6 13C6 11.6192 4.88083 10.5 3.5 10.5C2.11917 10.5 1 11.6192 1 13C1 14.3808 2.11917 15.5 3.5 15.5ZM3.5 11.0556C4.57194 11.0556 5.44444 11.9278 5.44444 13C5.44444 14.0722 4.57194 14.9444 3.5 14.9444C2.42806 14.9444 1.55556 14.0722 1.55556 13C1.55556 11.9278 2.42806 11.0556 3.5 11.0556Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.5 10.5C12.1192 10.5 11 11.6192 11 13C11 14.3808 12.1192 15.5 13.5 15.5C14.8808 15.5 16 14.3808 16 13C16 11.6192 14.8808 10.5 13.5 10.5ZM13.5 14.9444C12.4281 14.9444 11.5556 14.0722 11.5556 13C11.5556 11.9278 12.4281 11.0556 13.5 11.0556C14.5719 11.0556 15.4444 11.9278 15.4444 13C15.4444 14.0722 14.5719 14.9444 13.5 14.9444Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.5 10.5C22.1192 10.5 21 11.6192 21 13C21 14.3808 22.1192 15.5 23.5 15.5C24.8808 15.5 26 14.3808 26 13C26 11.6192 24.8808 10.5 23.5 10.5ZM23.5 14.9444C22.4281 14.9444 21.5556 14.0722 21.5556 13C21.5556 11.9278 22.4281 11.0556 23.5 11.0556C24.5719 11.0556 25.4444 11.9278 25.4444 13C25.4444 14.0722 24.5719 14.9444 23.5 14.9444Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.5 20.5C12.1192 20.5 11 21.6192 11 23C11 24.3808 12.1192 25.5 13.5 25.5C14.8808 25.5 16 24.3808 16 23C16 21.6192 14.8808 20.5 13.5 20.5ZM13.5 24.9444C12.4281 24.9444 11.5556 24.0722 11.5556 23C11.5556 21.9278 12.4281 21.0556 13.5 21.0556C14.5719 21.0556 15.4444 21.9278 15.4444 23C15.4444 24.0722 14.5719 24.9444 13.5 24.9444Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.5 15.5C7.11917 15.5 6 16.6192 6 18C6 19.3808 7.11917 20.5 8.5 20.5C9.88083 20.5 11 19.3808 11 18C11 16.6192 9.88083 15.5 8.5 15.5ZM8.5 19.9444C7.42806 19.9444 6.55556 19.0722 6.55556 18C6.55556 16.9278 7.42806 16.0556 8.5 16.0556C9.57194 16.0556 10.4444 16.9278 10.4444 18C10.4444 19.0722 9.57194 19.9444 8.5 19.9444Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.5 15.5C17.1192 15.5 16 16.6192 16 18C16 19.3808 17.1192 20.5 18.5 20.5C19.8808 20.5 21 19.3808 21 18C21 16.6192 19.8808 15.5 18.5 15.5ZM18.5 19.9444C17.4281 19.9444 16.5556 19.0722 16.5556 18C16.5556 16.9278 17.4281 16.0556 18.5 16.0556C19.5719 16.0556 20.4444 16.9278 20.4444 18C20.4444 19.0722 19.5719 19.9444 18.5 19.9444Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.5 10.5C9.88083 10.5 11 9.38083 11 8C11 6.61917 9.88083 5.5 8.5 5.5C7.11917 5.5 6 6.61917 6 8C6 9.38083 7.11917 10.5 8.5 10.5ZM8.5 6.05556C9.57194 6.05556 10.4444 6.92778 10.4444 8C10.4444 9.07222 9.57194 9.94444 8.5 9.94444C7.42806 9.94444 6.55556 9.07222 6.55556 8C6.55556 6.92778 7.42806 6.05556 8.5 6.05556Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M18.5 10.5C19.8808 10.5 21 9.38083 21 8C21 6.61917 19.8808 5.5 18.5 5.5C17.1192 5.5 16 6.61917 16 8C16 9.38083 17.1192 10.5 18.5 10.5ZM18.5 6.05556C19.5719 6.05556 20.4444 6.92778 20.4444 8C20.4444 9.07222 19.5719 9.94444 18.5 9.94444C17.4281 9.94444 16.5556 9.07222 16.5556 8C16.5556 6.92778 17.4281 6.05556 18.5 6.05556Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.a3070602.svg";
export { ForwardRef as ReactComponent };